<template>
  <div class="chat-contact-form-submit-button">
    <custom-button
      class="font-medium contact-form-submit send-message-mail-button"
      block
      :bg-color="widgetColor"
      :text-color="textColor"
      :disabled="isSending"
      @click="onSubmit"
    >
      <spinner v-if="isSending" class="p-0" />
      {{ $t('SEND_EMAIL') }}
      <img :src="sendMessageArrowIcon" alt="Send Icon" />
    </custom-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CustomButton from 'shared/components/Button';
import Spinner from 'shared/components/Spinner';

import { getContrastingTextColor } from '@chatwoot/utils';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import sendMessageArrowIcon from '../assets/images/sendMessageArrowIcon.svg';

export default {
  name: 'ChatContactFormSubmit',
  components: { CustomButton, Spinner },
  props: {
    messages: {
      type: Array
    }
  },
  data() {
    return {
      isSending: false,
      sendMessageArrowIcon
    };
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor'
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    lastMessageId() {
      if (!Array.isArray(this.messages) || this.messages.length === 0) {
        return;
      }

      let lastMessage = null;

      this.messages.forEach(day => {
        if (day.messages && Array.isArray(day.messages)) {
          day.messages.forEach(message => {
            if (message?.id) {
              lastMessage = message;
            }
          });
        }
      });

      if (lastMessage === null) {
        return null;
      }

      return lastMessage.id;
    }
  },
  methods: {
    onSubmit() {
      if (this.isSending) return;
      this.isSending = true;
      window.bus.$emit(BUS_EVENTS.CHAT_CONTACT_FORM_SUBMIT, this.lastMessageId);
    }
  },
  mounted() {
    window.bus.$on(
      'CHAT_CONTACT_FORM_SUBMIT_RESET_STATE',
      () => (this.isSending = false)
    );
  }
};
</script>
